import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';
import { getFullImageUrl } from 'client/utils/image-helpers';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

const MAX_COLUMN_NUMBER = 12;

export function RelatedContentItem({
  url,
  blank,
  nofollow,
  photoUrl,
  title,
  className,
  columnNumber,
  photoSize,
  aspectRatio,
  componentToUse = 'a',
}) {
  const isAnchor = componentToUse === 'a';
  const renderContent = () => (
    <Fragment>
      <AspectRatioContainer aspectRatio={aspectRatio} className="mb-0_5">
        {/* alt is redundant as long as title is adjacent: https://dequeuniversity.com/rules/axe/3.1/image-redundant-alt */}
        <img className="w-100 rounded" src={getFullImageUrl(photoUrl, photoSize)} alt="" loading={'lazy'} />
      </AspectRatioContainer>
      <div className="title">{title}</div>
    </Fragment>
  );
  if (!isAnchor) {
    return (
      <Col
        key={url}
        className={className}
        xs={MAX_COLUMN_NUMBER / columnNumber.MOBILE}
        md={MAX_COLUMN_NUMBER / columnNumber.DESKTOP}
        tag={componentToUse}
      >
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a
          href={url}
          target={blank ? '_blank' : null}
          rel={nofollow ? 'nofollow' : null}
          data-tracking-id="inline_article_view_content"
          data-tracking-value={title}
        >
          {renderContent()}
        </a>
      </Col>
    );
  }

  return (
    <Col
      key={url}
      className={className}
      xs={MAX_COLUMN_NUMBER / columnNumber.MOBILE}
      md={MAX_COLUMN_NUMBER / columnNumber.DESKTOP}
      tag={componentToUse}
      href={url}
      target={blank ? '_blank' : null}
      rel={nofollow ? 'nofollow' : null}
      data-tracking-id="inline_article_view_content"
      data-tracking-value={title}
    >
      {renderContent()}
    </Col>
  );
}

RelatedContentItem.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  nofollow: PropTypes.bool.isRequired,
  blank: PropTypes.bool.isRequired,
  photoUrl: PropTypes.string.isRequired,
  columnNumber: PropTypes.shape({
    MOBILE: PropTypes.number,
    DESKTOP: PropTypes.number,
  }).isRequired,
  photoSize: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
  aspectRatio: PropTypes.string,
  componentToUse: PropTypes.string,
};
